import Modal from "@components/atoms/Modal";
import BmhForm from "@components/molecules/BMH/BmhForm";
import RequestViewCard from "@components/molecules/RequestViewCard";
import { getRequestType, RequestTypes } from "@scenes/requests/utils/utils";
import { Button, Spacer } from "@components/atoms";
import React, { useState } from "react";
import styled, { DefaultTheme, useTheme } from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useBulkRequestState } from "@scenes/requests/context/BulkStateContext";
import { useTranslation } from "react-i18next";
import { productNameToTokenCategory } from "@utils/index";
import { RequestType } from "@scenes/bulk-request/Utils";
import { getProductColor } from "@utils/product/productTheme";

type BulkItemEditModalProps = {
  productType: any;
  stockItemRequest: any;
  selectedItem: any;
  open: any;
  setOpen: any;
};

const BulkItemEditModal = ({
  productType,
  stockItemRequest,
  selectedItem,
  open,
  setOpen,
}: BulkItemEditModalProps) => {
  const { t } = useTranslation();
  const requestType = getRequestType(stockItemRequest?.request_type);
  const { setItems } = useBulkRequestState() || {};
  const [dataBuy, setDataBuy] = useState();
  const [dataMemo, setDataMemo] = useState<{ memoComments: string }>();

  const theme = useTheme();

  const onSaveData = () => {
    if (selectedItem) {
      setItems((old: any) => {
        const exists: {
          offer_price_per_carat?: number;
          offer_total_sales_price?: number;
          offer_discount_percent?: number;
          stock_item_request_id?: number;
          comments?: string;
          hold_hours?: number;
        } = {};
        if (requestType?.toLowerCase() === "buy") {
          exists.offer_price_per_carat =
            dataBuy?.offer_price_per_carat ??
            stockItemRequest?.offer_price_per_carat;
          exists.offer_total_sales_price =
            dataBuy?.offer_total_sales_price ??
            stockItemRequest?.offer_total_sales_price;
          exists.offer_discount_percent =
            dataBuy?.offer_discount_percent ??
            stockItemRequest?.offer_discount_percent;
          exists.stock_item_request_id = dataBuy?.itemId;
          exists.comments = dataBuy?.buyComments;
        }
        if (requestType?.toLowerCase() === "memo") {
          exists.stock_item_request_id = dataMemo?.itemId;
          exists.comments = dataMemo?.memoComments;
        }

        if (requestType?.toLowerCase() === "hold") {
          exists.stock_item_request_id = dataMemo?.itemId;
          exists.comments = dataMemo?.memoComments;
          // exists.hold_hours = dataHold?.hold_hours;
        }

        const newData = old.filter(
          (item) => item.stock_item_request_id !== selectedItem.id
        );
        setOpen(false);
        return [...newData, exists];
      });
    }
  };

  return (
    <Modal
      headerTitle={`${t("bulkInitScreen.editBulkItem.modal.title.text")} ${
        selectedItem?.[productType?.productType]?.long_title
      }`}
      isOpen={open}
      onClose={() => {
        setOpen(false);
      }}
      paddingLeft={0}
      paddingRight={0}
      paddingTop={0}
      paddingBottom={0}
      skipKeyboardAware={true}
      size={"md"}
      headerBackgroundColor={theme[getProductColor(productType?.productType)]}
      headerTextColor={theme["core-01"]}
      backgroundColor={theme["core-02"]}
    >
      <BmhForm
        HeaderComponent={() =>
          requestType !== RequestTypes.Memo ? (
            <>
              <RequestViewCard
                stockItemRequest={selectedItem}
                productType={productType}
                selectedOption={requestType}
                showCheckbox={false}
              />
              <Spacer size={SpaceType.Extra} />
            </>
          ) : (
            <Spacer size={SpaceType.Double} />
          )
        }
        selectedOption={
          getRequestType(stockItemRequest?.request_type)?.toLowerCase() ===
          RequestType.BUY
            ? RequestType.BUY
            : RequestType.MEMO
        }
        canRequestAgain={{ can_request_again: true }}
        stockItemRequest={selectedItem}
        itemDetail={selectedItem}
        onDataBuyChange={setDataBuy}
        onDataMemoChange={setDataMemo}
        disableRequestButton={() => null}
        onModify={true}
        fromRequestDetail={true}
        isBulk={true}
      />
      <ButtonsContainer>
        {requestType === RequestTypes.Buy && (
          <ButtonWrap themeColor={getProductColor(productType?.productType)}>
            <Button
              title={"Remove from the List"}
              category={productNameToTokenCategory(productType?.productType)}
            />
          </ButtonWrap>
        )}

        <ButtonWrap themeColor={getProductColor(productType?.productType)}>
          <Button
            onPress={() => onSaveData()}
            title={"Save"}
            category={productNameToTokenCategory(productType?.productType)}
          />
        </ButtonWrap>
      </ButtonsContainer>
    </Modal>
  );
};

const ButtonsContainer = styled.View`
  flex-direction: row;
  gap: ${SpaceType.Big}px;
  margin-top: ${SpaceType.ExtraLarge}px;
  margin-bottom: ${SpaceType.Big}px;
  justify-content: center;
`;

const ButtonWrap = styled.View<{ themeColor: string }>`
  flex: 1;
  max-width: 343px;
  border-radius: ${SpaceType.Small}px;
  background-color: ${({ theme, themeColor }) =>
    theme[themeColor as keyof DefaultTheme] as string};
`;

export default BulkItemEditModal;
